import { Component } from '@theme/component';

/**
 * Highlights the hovered or focused occasion and reveals its matching image panel.
 * Each occasion block contains its own panel; the active occasion gets `data-active`.
 * Without JavaScript the first panel stays visible and every occasion remains a plain link.
 *
 * @extends Component
 */
class CpOccasionsComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#activateFirst();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#activateFirst();
  }

  /**
   * Activates the occasion that received pointer or keyboard focus.
   * @param {Event} event - pointerenter or focus event routed from an occasion row.
   */
  activate(event) {
    const { target } = event;
    if (!(target instanceof HTMLElement)) return;

    const occasion = target.closest('[data-occasion]');
    if (!(occasion instanceof HTMLElement)) return;

    const index = this.#occasions.indexOf(occasion);
    if (index !== -1) this.#setActive(index);
  }

  get #occasions() {
    return /** @type {HTMLElement[]} */ ([...this.querySelectorAll('[data-occasion]')]);
  }

  #activateFirst() {
    if (this.#occasions.length === 0) return;

    this.classList.add('cp-occasions--ready');
    this.#setActive(0);
  }

  /** @param {number} index */
  #setActive(index) {
    this.#occasions.forEach((occasion, i) => occasion.toggleAttribute('data-active', i === index));
  }
}

if (!customElements.get('cp-occasions-component')) {
  customElements.define('cp-occasions-component', CpOccasionsComponent);
}
